<script setup lang="ts">
import { OperationModelType } from "~/core/models/OperationModelType.enum";
import {
  type FilterFormSection,
  FilterInputType,
  Filters,
  type FilterSelectionValue,
  type FiltersSelection,
  type Option,
} from "~/core/models/filters";
import { CampaignOMStatus } from "~/modules/campaign/models/CampaignOMStatus.enum";

defineProps<{
  filters: FiltersSelection;
}>();

const emit = defineEmits(["change", "enter"]);

const { t } = useI18n();

const statusLabel = t("campaign.operationMgr.filters.status");
const typeLabel = t("campaign.operationMgr.filters.type");

const filtersStatusOptions: Ref<Option[]> = ref(
  Object.values(CampaignOMStatus).map((value) => {
    return {
      value,
      label: t(`campaign.list.column.status.value.${value}`),
    };
  }),
);

const filtersTypeOptions: Ref<Option[]> = ref(
  Object.values(OperationModelType).map((value) => {
    return {
      value,
      label: t(`campaign.funnel.campaignSettings.operationModelType.${value}`),
    };
  }),
);

const filterFormSections: FilterFormSection[] = [
  {
    disabled: false,
    filter: Filters.CAMPAIGN_STATUS,
    footerEnabled: true,
    footerId: "status-footer",
    header: statusLabel,
    id: "status",
    inputType: FilterInputType.CHECKBOX,
    menuLabel: statusLabel,
    options: filtersStatusOptions,
    tagPrefix: statusLabel,
    translate: true,
  },
  {
    disabled: false,
    filter: Filters.CAMPAIGN_TYPE,
    footerEnabled: true,
    footerId: "type-footer",
    header: typeLabel,
    id: "type",
    inputType: FilterInputType.CHECKBOX,
    menuLabel: typeLabel,
    options: filtersTypeOptions,
    tagPrefix: typeLabel,
    translate: true,
  },
];

function setFilter(filter: Filters, value: FilterSelectionValue) {
  emit("change", filter, value);
}
</script>

<template>
  <filters-component
    :filter-sections="filterFormSections"
    :filters="filters"
    is-button-right
    @change="setFilter"
    @enter="emit('enter', $event)"
  />
</template>
